export default __webpack_public_path__ + "static/media/suitable.2da4ce28.svg";